global.CKEDITOR_BASEPATH = '/build/ckeditor/';
require('ckeditor4-nonlts/ckeditor');
